
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, Dot } from 'recharts'
import { ReactElement } from 'react';


interface DataPoint {
    mes: string;
    ano: number,
    anoAnterior: number,
    totalAno: number;
    totalAnoAnterior: number;
    
  }

interface CustomTooltipProps {
    active?: boolean;
    payload?: { payload: DataPoint; stroke?: string }[];
    label?: string;
}

  const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 
               'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

export default function GraficoLinhas(props: any) {

    const { dataCharts, origem, tipoRel, setShow, setAnoSelect } = props

    

    const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const item = payload[0].payload;

            return (
            <div className="custom-tooltip" style={{ background: "#fff", padding: 10, borderRadius: 6 }}>
                <div style={{ textAlign: "left" }}>
                <span style={{ color: payload[0].stroke }}>
                    {`${meses[Number(label) - 1] || label}/${item.ano}: R$ ${ new Intl.NumberFormat("pt-BR", {
                        notation: "compact",
                        compactDisplay: "short",
                        }).format(item.totalAno)}`}
                </span>
                <div style={{ marginBottom: 5 }} />
                <span style={{ color: payload[1]?.stroke }}>
                    {`${meses[Number(label) - 1] || label}/${item.anoAnterior}: R$ ${ new Intl.NumberFormat("pt-BR", {
                        notation: "compact",
                        compactDisplay: "short",
                        }).format(item.totalAnoAnterior)}`}
                </span>
                </div>
            </div>
            );
        }

        return null;
    };

    

    return (


        <div>

            <ResponsiveContainer width="100%" height={300}>

                                            

            <LineChart
                data={dataCharts ?? []}
                margin={{ top: 20, right: 20, bottom: 5, left: 0 }} // ⬅️ aumenta aqui
                >

            <Line
                type="monotone"
                dataKey="totalAno"
                stroke="#8884d8"
                label={({ x, y, value }: any): ReactElement<SVGElement> => {
                    if (value == null) return <g />;
                  
                    const formatted = new Intl.NumberFormat("pt-BR", {
                      notation: "compact",
                      compactDisplay: "short",
                    }).format(Number(value));
                  
                    return (
                      <text
                        x={x}
                        y={y - 10}
                        fill="#000"
                        fontSize={11}
                        textAnchor="middle"
                      >
                        {formatted}
                      </text>
                    );
                  }}
                dot={true}
                />

                <Line
                type="monotone"
                dataKey="totalAnoAnterior"
                stroke="#bf714b"
                label={false}
                dot={true}
                />

                <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />

                <XAxis
                dataKey="mes"
                tickFormatter={(mes) => meses[Number(mes) - 1] || mes}
                style={{ fontSize: '11px', fontFamily: 'Arial' }}
                />

                <YAxis
                tickFormatter={(value) =>
                    new Intl.NumberFormat("pt-BR", {
                    notation: "compact",
                    compactDisplay: "short",
                    }).format(value)
                }
                style={{ fontSize: '10px', fontFamily: 'Arial' }}
                />

                <Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }} />

                </LineChart>




            </ResponsiveContainer>
            
            


        </div>


    )


}